<!--Footer Starts-->
<footer class="footer">
</footer>
<!--Footer Ends-->
